import "core-js/modules/es6.regexp.replace";
import React from 'react';

function DefaultValue(_ref) {
  var value = _ref.value,
      isElementType = _ref.isElementType;
  if (value == null || value === 'undefined') return null; // eslint-disable-next-line no-param-reassign

  if (isElementType) value = "<".concat(value.replace(/('|")/g, ''), ">");
  return /*#__PURE__*/React.createElement("code", null, value);
}

export default DefaultValue;